<template>
  <div>polar-chart.vue</div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped></style>
